/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ArrayNode } from '../models/ArrayNode';
import type { CollectionCountResult } from '../models/CollectionCountResult';
import type { CollectionFilterRequest } from '../models/CollectionFilterRequest';
import type { JsonNode } from '../models/JsonNode';
import type { OnlyFansSubscriberResult } from '../models/OnlyFansSubscriberResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OfCollectionsService {
    /**
     * Get subscribes list
     * Retrieve a list of subscribes for the creator. In the filter only paid and online are permitted to set.
     * @returns OnlyFansSubscriberResult OK
     * @throws ApiError
     */
    public static getSubscribes({
        creatorId,
        offset,
        type,
        order,
        sort,
        query,
        requestBody,
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
        /**
         * The starting point of the list to retrieve.
         */
        offset: number,
        /**
         * Type of subscribes to retrieve ('all', 'active', 'expired' and 'attention')
         */
        type: string,
        /**
         * Order by field (Recent: 'last_activity', Subscription 'expire_date', Started 'subscribe_date')
         */
        order: string,
        /**
         * Sort of the order (desc or asc)
         */
        sort: string,
        /**
         * Optional query string
         */
        query: string,
        requestBody: CollectionFilterRequest,
    }): CancelablePromise<OnlyFansSubscriberResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-collections/{creatorId}/subscribes',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'offset': offset,
                'type': type,
                'order': order,
                'sort': sort,
                'query': query,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get subscribers list
     * Retrieve a list of subscribers for the creator. - Filter spent_date_start and spent_date_end filter only applies for type='activity'. - Filter Offline (online=0) check is forbidden. - This endpoint does not support sorting & order
     * @returns OnlyFansSubscriberResult OK
     * @throws ApiError
     */
    public static getSubscribers({
        creatorId,
        offset,
        type,
        query,
        requestBody,
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
        /**
         * The starting point of the list to retrieve.
         */
        offset: number,
        /**
         * The type of following ('all', 'active', 'expired', 'activity').
         */
        type: string,
        /**
         * Optional query string
         */
        query: string,
        requestBody: CollectionFilterRequest,
    }): CancelablePromise<OnlyFansSubscriberResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-collections/{creatorId}/subscribers',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'offset': offset,
                'type': type,
                'query': query,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get restricted users list
     * Retrieve a list of restricted users for the creator. - The OnlyFansSubscriberResult will not have a count. - This endpoint does not support sorting & order
     * @returns OnlyFansSubscriberResult OK
     * @throws ApiError
     */
    public static getRestricted({
        creatorId,
        offset,
        query,
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
        /**
         * The starting point of the list to retrieve.
         */
        offset: number,
        /**
         * Optional query string
         */
        query: string,
    }): CancelablePromise<OnlyFansSubscriberResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-collections/{creatorId}/restricted',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'offset': offset,
                'query': query,
            },
        });
    }
    /**
     * Switch pin status of a user in a list
     * Switch the pin status of a user in a specific list for the creator.
     * @returns any OK
     * @throws ApiError
     */
    public static pinUser({
        creatorId,
        listId,
        userId,
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
        /**
         * The ID of the list.
         */
        listId: number,
        /**
         * The ID of the user.
         */
        userId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-collections/{creatorId}/list/{listId}/pin/{userId}',
            path: {
                'creatorId': creatorId,
                'listId': listId,
                'userId': userId,
            },
        });
    }
    /**
     * Clear list
     * Delete all users from a specific list
     * @returns any OK
     * @throws ApiError
     */
    public static clearList({
        creatorId,
        listId,
    }: {
        creatorId: number,
        listId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-collections/{creatorId}/list/{listId}/clearList',
            path: {
                'creatorId': creatorId,
                'listId': listId,
            },
        });
    }
    /**
     * Add users in a batch
     * Add multiple users at once to a list
     * @returns any OK
     * @throws ApiError
     */
    public static addUsersToList({
        creatorId,
        listId,
        requestBody,
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
        /**
         * The ID of the list.
         */
        listId: number,
        requestBody: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-collections/{creatorId}/list/{listId}/addUsersBatch',
            path: {
                'creatorId': creatorId,
                'listId': listId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Custom order
     * Set custom order for user lists
     * @returns any OK
     * @throws ApiError
     */
    public static setCustomOrder({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: ArrayNode,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-collections/{creatorId}/list/setCustomOrder',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get blocked users list
     * Retrieve a list of blocked users for the creator.- The OnlyFansSubscriberResult will not have a count.
     * @returns OnlyFansSubscriberResult OK
     * @throws ApiError
     */
    public static getBlocked({
        creatorId,
        offset,
        order,
        sort,
        query,
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
        /**
         * The starting point of the list to retrieve.
         */
        offset: number,
        /**
         * The order field ('default': Default or 'recent': Recent)
         */
        order: string,
        /**
         * The sorting asc or desc
         */
        sort: string,
        /**
         * Optional query string
         */
        query: string,
    }): CancelablePromise<OnlyFansSubscriberResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-collections/{creatorId}/blocked',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'offset': offset,
                'order': order,
                'sort': sort,
                'query': query,
            },
        });
    }
    /**
     * Subscribe history
     * Retrieve a list of users in a specific list for the creator.- First fetch all users with pinned=true, then pinned=false.- Note that pinned users are supplied as duplicates from the OF API,so ignore all pinned users when receiving the non pinned ones.
     * @returns JsonNode OK
     * @throws ApiError
     */
    public static history({
        creatorId,
        userId,
        offset,
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
        /**
         * The ID of the user.
         */
        userId: number,
        /**
         * The offset parameter
         */
        offset: number,
    }): CancelablePromise<JsonNode> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-collections/{creatorId}/subscriptions/{userId}/history',
            path: {
                'creatorId': creatorId,
                'userId': userId,
            },
            query: {
                'offset': offset,
            },
        });
    }
    /**
     * List users in a list
     * Retrieve a list of users in a specific list for the creator.- First fetch all users with pinned=true, then pinned=false.- Note that pinned users are supplied as duplicates from the OF API,so ignore all pinned users when receiving the non pinned ones.
     * @returns OnlyFansSubscriberResult OK
     * @throws ApiError
     */
    public static listUsers({
        creatorId,
        listId,
        pinned,
        offset,
        order,
        sort,
        query,
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
        /**
         * The ID of the list.
         */
        listId: number,
        /**
         * Whether to retrieve pinned users.
         */
        pinned: boolean,
        /**
         * The starting point of the list to retrieve.
         */
        offset: number,
        /**
         * The order field ('default': Default or 'recent': Recent)
         */
        order: string,
        /**
         * The sorting asc or desc
         */
        sort: string,
        /**
         * Optional query string
         */
        query: string,
    }): CancelablePromise<OnlyFansSubscriberResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-collections/{creatorId}/list/{listId}/users',
            path: {
                'creatorId': creatorId,
                'listId': listId,
            },
            query: {
                'pinned': pinned,
                'offset': offset,
                'order': order,
                'sort': sort,
                'query': query,
            },
        });
    }
    /**
     * Get subscription counts
     * Retrieve the count of all subscriptions and subscribers by type for the creator.
     * @returns CollectionCountResult OK
     * @throws ApiError
     */
    public static getCount({
        creatorId,
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
    }): CancelablePromise<CollectionCountResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-collections/{creatorId}/count',
            path: {
                'creatorId': creatorId,
            },
        });
    }
    /**
     * Clear all promotions
     * Clear all promotions for the creator.
     * @returns any OK
     * @throws ApiError
     */
    public static clearPromotions({
        creatorId,
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/of-collections/{creatorId}/promotions/clear',
            path: {
                'creatorId': creatorId,
            },
        });
    }
}
